import { Alert, Button, Space } from 'antd';
import {
  useAcceptOrganizationInviteMutation,
  useDeclineOrganizationInviteMutation,
  useGetAllOrganizationInvitesQuery
} from 'api/OrganizationInvitesApi';

function OrganizationInvite() {
  const { data: organizationInvites } = useGetAllOrganizationInvitesQuery();
  const [acceptInvite, { isLoading: isLoadingAccept }] = useAcceptOrganizationInviteMutation();
  const [declineInvite, { isLoading: isLoadingDecline }] = useDeclineOrganizationInviteMutation();

  const handleAccept = async (id: string) => {
    try {
      await acceptInvite({ id }).unwrap();
    } catch (e) {
      console.error(e);
    }
  };
  const handleDecline = async (id: string) => {
    try {
      await declineInvite({ id }).unwrap();
    } catch (e) {
      console.error(e);
    }
  };

  const isLoading = isLoadingAccept || isLoadingDecline;

  return (
    <>
      <div className="organization-invite">
        {(organizationInvites || []).map((invite) => (
          <Alert
            key={invite.id}
            description={
              <>
                You were invited to join an organization <strong>{invite.tenantOrganization.name}</strong>.
              </>
            }
            type="info"
            action={
              <Space direction="horizontal">
                <Button size="small" type="primary" onClick={() => handleAccept(invite.id)} disabled={isLoading}>
                  Accept
                </Button>
                <Button size="small" danger ghost onClick={() => handleDecline(invite.id)} disabled={isLoading}>
                  Decline
                </Button>
              </Space>
            }
          />
        ))}
      </div>
    </>
  );
}

export default OrganizationInvite;
